import { AUTH_LOGOUT_SUCCESS, LOAD_USER_REFERRAL_IDENTIFIER_SUCCESS, LOAD_USER_SUCCESS, MODIFY_USER_SUCCESS, LOAD_CART_SUCCESS, LOAD_USER_STORE_CREDIT_EVENTS_SUCCESS, LOAD_USER_ADDRESS_BOOK_SUCCESS, MODIFY_USER_ADDRESS_BOOK_SUCCESS, REMOVE_FROM_USER_ADDRESS_BOOK_SUCCESS } from '../actions/types';
import initialState from '../store/initial-state';
// eslint-disable-next-line default-param-last
const user = function () {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState.user;
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case AUTH_LOGOUT_SUCCESS:
      return {
        data: {},
        referralIdentifier: null,
        storeCreditEvents: null
      };
    case LOAD_USER_REFERRAL_IDENTIFIER_SUCCESS:
      return {
        ...state,
        referralIdentifier: action.payload.referralIdentifier
      };
    case LOAD_USER_SUCCESS:
    case MODIFY_USER_SUCCESS:
      return {
        ...state,
        data: action.payload.data
      };
    case LOAD_CART_SUCCESS:
      {
        if (!action.data?.userId) return state;
        return {
          ...state,
          data: {
            ...state.data,
            id: action.data.userId
          }
        };
      }
    case LOAD_USER_STORE_CREDIT_EVENTS_SUCCESS:
      {
        return {
          ...state,
          storeCreditEvents: action.payload.data
        };
      }
    case LOAD_USER_ADDRESS_BOOK_SUCCESS:
    case MODIFY_USER_ADDRESS_BOOK_SUCCESS:
      {
        return {
          ...state,
          addressBook: action.payload.data
        };
      }
    case REMOVE_FROM_USER_ADDRESS_BOOK_SUCCESS:
      {
        return {
          ...state,
          addressBook: state.addressBook.filter(a => a.id !== action.payload.addressId)
        };
      }
    default:
      return state;
  }
};
export default user;